import { Suspense } from 'react'
import { Form } from "react-router-dom"
import { useActionData, useNavigation, useRouteLoaderData, Await, Link } from 'react-router-dom';
import AdminTeamsForm from '../../components/admin/AdminTeamsForm.jsx'
import AdminTeamsShow from '../../components/admin/AdminTeamsShow.jsx'
import { ListImages } from '../../repo/ImagesRepo.js'
import { TeamCreate } from '../../repo/TeamsRepo.js'

export default function TeamNewPage() {
  const response = useActionData()
  const createNavigation = useNavigation()
  const isSubmitting = createNavigation.state === 'submitting'
  const teamRelations = useRouteLoaderData('admin-team-new')

  return (
    <section className="m-8">
      {response && response.status && response.status  ? (
        <AdminTeamsShow team={response.data} status="created"/>
      ) : (
        <>
          <h1>Create New Team</h1>
          <div id="team-create-form" className={`w-full py-4 mb-4'`}>
            <Form method="POST" className="space-y-4 md:space-y-6 mt-4">
              <Suspense fallback={<p>Carregando...</p>}>
                <Await resolve={teamRelations}>
                  {(loadedTeamRelations) => <AdminTeamsForm images={loadedTeamRelations.images.data} errors={(response && response.errors) ? response.errors : null } isSubmitting={isSubmitting}/>}
                </Await>
              </Suspense>
            </Form>
          </div>

          <div id="teams" className={`w-full pt-4 mt-4'`}>
            <Link className="hover:no-underline underline" to="/cocofantoelefanto/teams">Back to Teams</Link>
          </div>
        </>
      )}
    </section>
  )
}

export async function action({request}) {
  const data = await request.formData()

  const teamData = {
    team: {
      name: data.get('name'),
      image_id: data.get('image_id'),
      third_party_label: data.get('third_party_label'),
      third_party_id: data.get('third_party_id')
    }
  }

  return await TeamCreate(teamData)
}

export async function loader({ params, request }) {
  return {
    images: await ListImages(1, { skip_confirmation: 1 }),
  }
}
